"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENDPOINT_BURST_POINTS = exports.DEVICE_IP_CEILING_MULTIPLIER = exports.DEFAULT_IP_CEILING_MULTIPLIER = exports.DEFAULT_RATE_LIMIT_WINDOW_SECONDS = exports.BROWSER_TABS_PER_DEVICE_BUDGET = exports.DEFAULT_RATE_LIMIT_POINTS = void 0;
exports.DEFAULT_RATE_LIMIT_POINTS = 10;
// The browser paces each tab at this share of a device budget, so two tabs of one browser fit in it.
exports.BROWSER_TABS_PER_DEVICE_BUDGET = 2;
exports.DEFAULT_RATE_LIMIT_WINDOW_SECONDS = 5;
// Budget of a caller without a verified device, who shares the IP bucket with everyone behind that IP.
exports.DEFAULT_IP_CEILING_MULTIPLIER = 3;
// Headroom for a venue (gala Wi-Fi, auction room) while bounding device rotation from one IP at about 30 devices' worth per endpoint and window.
exports.DEVICE_IP_CEILING_MULTIPLIER = 30;
// Burst points of endpoints that need more than the default, shared so the browser pacer follows the server.
exports.ENDPOINT_BURST_POINTS = {
    uploadImage: 16,
    searchContacts: 12,
    getCompaniesForDropdown: 12,
    form_getTicketingQuestions: 12,
    form_getHasRemainingDiscountsByTicketingId: 12,
    form_shouldDisplayAddressQuestion: 12,
    form_getActiveTicketingOccurrences: 12,
    form_getCommandBids: 12,
    form_getStoredFormVolume: 12,
    form_getFormFunds: 12,
    form_getHighestBidsPerRate: 12,
    form_getLatestDonations: 12,
};
